import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CignaIcon } from '@cigna/ui/icon';
import { ServiceError, Message, MessageFilters } from '@cigna/chcp/shared/util';
import { AsyncData } from '@cigna/core/interfaces';
import { defaultMessageCenterFilters } from '@cigna/chcp/shared/message-center-data-access';
import { subDays } from 'date-fns';

type MessageCenterViewType = 'all' | 'unread' | 'read' | '-7d' | '-30d';

@Component({
  selector: 'cigna-message-center-widget',
  templateUrl: './message-center-widget.component.html',
  styleUrls: ['./message-center-widget.component.scss', '../tile.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageCenterWidgetComponent {
  @Input() messages: AsyncData<Message[], ServiceError>;
  @Input() isImpersonator: boolean;

  @Output() fetchMessages: EventEmitter<MessageFilters> = new EventEmitter();

  CignaIcon = CignaIcon;

  selectedView: MessageCenterViewType = 'all';

  changeMessageView(view: MessageCenterViewType) {
    this.fetchMessages.emit({
      ...defaultMessageCenterFilters,
      read:
        view === 'unread'
          ? [{ value: 'unread', label: 'Unread', isSelected: true }]
          : defaultMessageCenterFilters.read,
      date:
        view === '-7d' || view === '-30d'
          ? {
              range: view,
              min: subDays(new Date(), view === '-7d' ? 7 : 30),
              max: new Date(),
            }
          : defaultMessageCenterFilters.date,
    });
  }

  public trackByFunc(index: number, message: Message): string {
    return message.id;
  }
}
